/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_UntilInputs */

const he_notifications_expiration_until = /** @type {(inputs: Notifications_Expiration_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עד`)
};

const en_notifications_expiration_until = /** @type {(inputs: Notifications_Expiration_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until`)
};

/**
* | output |
* | --- |
* | "Until" |
*
* @param {Notifications_Expiration_UntilInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_until = /** @type {((inputs?: Notifications_Expiration_UntilInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_UntilInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_until(inputs)
	return en_notifications_expiration_until(inputs)
});